import { Trash2, X } from "lucide-react";

export function NavButton({ active, onClick, icon, label, badge, testid }) {
  return <button className={`nav-button ${active ? "active" : ""}`} data-testid={testid} onClick={onClick}>{icon}<span>{label}</span>{badge > 0 && <em data-testid={`${testid}-badge`}>{badge}</em>}</button>;
}

export function sectionTitle(section) {
  return { dashboard: "Overview", inventory: "Inventory", dispatch: "Dispatch desk", activity: "Stock activity", trends: "Trends", reports: "Reports", kitchen: "Kitchen Usage", settings: "Plant details" }[section];
}

export function ConfirmModal({ title, message, onCancel, onConfirm, testid }) {
  return <div className="modal-backdrop" role="dialog" aria-modal="true" data-testid={`${testid}-confirm-dialog`}>
    <div className="modal confirm-modal">
      <div className="modal-header"><h2>{title}</h2><button data-testid={`${testid}-confirm-close-button`} onClick={onCancel} aria-label="Close"><X size={19} /></button></div>
      <p className="confirm-message">{message}</p>
      <div className="modal-actions">
        <button type="button" className="button ghost" data-testid={`${testid}-confirm-cancel-button`} onClick={onCancel}>Cancel</button>
        <button type="button" className="button danger" data-testid={`${testid}-confirm-delete-button`} onClick={onConfirm}><Trash2 size={15} /> Delete permanently</button>
      </div>
    </div>
  </div>;
}

export function Field({ label, testid, ...props }) { return <label>{label}<input data-testid={testid} {...props} /></label>; }
export function SelectField({ label, testid, options, ...props }) { return <label>{label}<select data-testid={testid} {...props}>{options.map((x) => <option key={x}>{x}</option>)}</select></label>; }
export function Modal({ title, children, onClose }) { return <div className="modal-backdrop" role="dialog" aria-modal="true"><div className="modal"><div className="modal-header"><h2>{title}</h2><button data-testid="modal-close-button" onClick={onClose} aria-label="Close"><X size={19} /></button></div>{children}</div></div>; }
